import { useSelector } from "react-redux";
import { MdOutlineImage, MdOutlineInventory2 } from "react-icons/md";
import { setdata } from "../../../../../../../helpers/helpers";
import { fetchOnlyProducts } from "../../../../../../../services/product.service";
import { GridShell, GridTile, sizeSpec, useGridData, weightSpec } from "./GridParts";
import { primaryImage, stockLocations, stockTotal } from "./ProductCells";

// The Products grid: one tile per product (page size, search, skeleton and
// footer from useGridData; the page size was a fixed 24). A click adds the
// product as before; without a location the tile keeps the old hint.
export default function ProductGridView(props) {
  const { StepCheck, handlescrollpackage, setFilter } = props;
  const user = useSelector((state) => state.user);
  const grid = useGridData({
    fetchPage: fetchOnlyProducts,
    setFilter,
    placeholder: "Search Products",
  });

  // Size and weight as the list shows them; Stock is the list's total, with
  // the per-location split on hover.
  const tileSpecs = (row) => {
    const packages =
      row?.package_details && Object.values(row.package_details).length > 0
        ? Object.values(row.package_details).length
        : 0;
    const split = stockLocations(row, user?.user_approved_warehouses, StepCheck["Warehouses"])
      .map((location) => `${location.name} ${location.quantity}`)
      .join(" · ");
    return [
      sizeSpec({
        row,
        unit: row?.dimension_unit?.toLowerCase(),
        kind: "product",
        badge: packages > 0 && (
          <span
            className="myprod__tile-badge"
            title={`Packed in ${packages} package${packages > 1 ? "s" : ""}`}
          >
            {packages}
          </span>
        ),
      }),
      weightSpec(row?.weight ?? "0", row?.weight_unit),
      {
        key: "stock",
        icon: <MdOutlineInventory2 aria-hidden="true" />,
        label: "Stock",
        value: stockTotal(row) ?? "—",
        title: split || undefined,
        tone: "stock",
      },
    ];
  };

  return (
    <GridShell grid={grid} emptyText="No Products to display!">
      {grid.items.map((data, index) => (
        <GridTile
          key={data?.id ?? index}
          name={setdata(() => data.name, false, "")}
          sub={data?.code ?? "-"}
          photo={primaryImage(data)}
          icon={<MdOutlineImage aria-hidden="true" />}
          specs={tileSpecs(data)}
          blocked={!StepCheck["Warehouses"]}
          onClick={() => handlescrollpackage(data)}
        />
      ))}
    </GridShell>
  );
}
